import { useEffect } from "react";
import { Navigate, useParams, type RouteObject } from "react-router";

import { useSession } from "@/app/session/useSession";

/* Bookmarks from the previous app keep working: every old URL lands on its new home. */

function To({ path }: { path: (params: Readonly<Record<string, string | undefined>>) => string }) {
  const params = useParams();
  return <Navigate to={path(params)} replace />;
}

function SignOutRoute() {
  const { signOut } = useSession();
  useEffect(() => {
    void signOut();
  }, [signOut]);
  return <Navigate to="/sign-in" replace />;
}

export const legacyRedirects: RouteObject[] = [
  { path: "/signin", element: <Navigate to="/sign-in" replace /> },
  { path: "/signup", element: <Navigate to="/sign-in" replace /> },
  { path: "/pass-reset", element: <Navigate to="/forgot-password" replace /> },
  { path: "/verify-otp", element: <Navigate to="/verify-code" replace /> },
  { path: "/pass-change", element: <Navigate to="/new-password" replace /> },
  { path: "/logout", element: <SignOutRoute /> },
  { path: "/dashboard", element: <Navigate to="/" replace /> },
  { path: "/inventory", element: <Navigate to="/units" replace /> },
  { path: "/inventory/:id", element: <To path={(p) => `/units/${p.id ?? ""}`} /> },
  {
    path: "/property-requests/:id?",
    element: <To path={(p) => (p.id ? `/units/${p.id}?tab=claims` : "/claims")} />,
  },
  { path: "/coldcalls", element: <Navigate to="/cold-calls" replace /> },
  { path: "/farming", element: <Navigate to="/resale" replace /> },
  { path: "/farming/:id", element: <To path={(p) => `/resale/${p.id ?? ""}`} /> },
  { path: "/lead-profile/:id?", element: <To path={(p) => `/leads/${p.id ?? ""}`} /> },
  { path: "/cold-call-profile/:id?", element: <To path={(p) => `/cold-calls/${p.id ?? ""}`} /> },
  { path: "/agent-profile", element: <Navigate to="/me" replace /> },
  { path: "/agent-profile-settings", element: <Navigate to="/me/settings" replace /> },
  { path: "/users", element: <Navigate to="/team" replace /> },
  { path: "/request-matches", element: <Navigate to="/requests" replace /> },
  { path: "/generated-offers", element: <Navigate to="/requests" replace /> },
];
